import { HttpApiMiddleware, HttpApiSchema } from "@effect/platform";
import * as S from "effect/Schema";
/** The caller's address has spent its web sign-up budget for the window. */
export const WebSignupRateLimited = S.Struct({
    _tag: S.Literal("WebSignupRateLimited"),
    retryAfterSeconds: S.Number,
}).annotations(HttpApiSchema.annotations({ status: 429 }));
/**
 * Admission to the public Dearest sign-up with a work address (PMO-371): a
 * per-address budget, much smaller than login discovery's, because every
 * admitted request can send a mail. Route middleware like `LoginMethodsGate`,
 * so it sees whatever request the router resolved to the route. apps/api
 * provides it and reads the caller's address from `CLIENT_ADDRESS_HEADER`.
 */
export class WebSignupGate extends HttpApiMiddleware.Tag()("@pima/web-api/WebSignupGate", { failure: WebSignupRateLimited }) {
}
//# sourceMappingURL=web-signup-gate.js.map